
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BpComponentsService, DetailBpLineinfos } from './../../bp-components.service';
import { SelectionModel } from '@angular/cdk/collections';
import { AfterContentChecked, ChangeDetectorRef, EventEmitter, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Component, Input, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { AmountComponentService } from 'src/app/core/amount.component.service';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { BpLineModel } from 'src/app/shared/models/societe-linked/bp/bp-line.model';
import { BpModel } from 'src/app/shared/models/societe-linked/bp/bp.model';
import { ModalCreateBpLineComponent } from '../../modals/modal-create-bp-line/modal-create-bp-line.component';

@Component({
  selector: 'app-bp-line-list-array',
  templateUrl: './bp-line-list-array.component.html',
  styleUrls: ['./bp-line-list-array.component.scss']
})
export class BpLineListArrayComponent implements OnChanges, AfterContentChecked{

  @ViewChild('table', { static: true }) table;
  @Input() form: UntypedFormGroup;
  @Input() detailInfos: DetailBpLineinfos;
  society: SocieteModel;
  bpLineFormArray: UntypedFormArray;
  showDelay = new UntypedFormControl(0);
  hideDelay = new UntypedFormControl(0);
  bpLine: BpLineModel;
  ValidationStatus: string[] = ['A Valider', 'Validation 1', 'Validation 2', 'Validation 3', 'Validation 4'];
  displayedColumnsBp: string[] = ['annule', 'code', 'position', 'libelle', 'qteBC', 'qteRestant', 'qteLivre', 'qteBP', 'puBC', 'puBP', 'htBC', 'htRestant', 'htBP', 'tva', 'naCode', 'cg', 'ca1', 'ca2', 'complement', 'equipement', 'codeAe', 'ttc'];
  matDataSourceBpLigne: MatTableDataSource<AbstractControl> = new MatTableDataSource<AbstractControl>();
  selection = new SelectionModel<AbstractControl>(true, []);
  bp: BpModel;
  @Output() selected: EventEmitter<SelectionModel<AbstractControl>> = new EventEmitter<SelectionModel<AbstractControl>>();
  @Output() amountHTsEmit = new EventEmitter<any[]>();
  @Output() amountTVAsEmit = new EventEmitter<any[]>();
  @Output() amountTTCsEmit = new EventEmitter<any[]>();

  amountHTs: any;
  amountTVAs: any;
  amountTTCs: any;

  constructor(private changeDetectorRef: ChangeDetectorRef,
              private amountService: AmountComponentService,
              private bpComponentsService: BpComponentsService,
              private dialog: MatDialog) {
    this.amountHTs = null;
    this.amountTVAs = null;
    this.amountTTCs = null;
  }

  ngOnChanges(changes: SimpleChanges): void{
    if (this.form) {
      this.bpLineFormArray = this.form.get('bpLines') as UntypedFormArray;
      this.reload();
      this.getCalculatedAMounts();
    }
  }

  reload(): void {
    if (this.bpLineFormArray) {
      this.matDataSourceBpLigne = new MatTableDataSource<AbstractControl>(this.bpLineFormArray.controls);
    }
  }

  ngAfterContentChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  openModal(i: number, row: UntypedFormGroup): void {
    this.bpLine = row.getRawValue();
    const bpLineRef = this.bpComponentsService.getBpLineRef(i);
    const modalData = {
      referentiel: bpLineRef,
      bpLineForm: row,
      titre: 'Modification d\'une ligne dans le BP'
    };
    const dialogRef = this.dialog.open(ModalCreateBpLineComponent, {
      autoFocus: false,
      disableClose: true,
      data: modalData
    });
    dialogRef.afterClosed().subscribe((res: UntypedFormGroup) => {
      if (res) {
        this.bpLineFormArray.at(i).patchValue(res.getRawValue());
      } else {
        this.bpLineFormArray.at(i).patchValue(this.bpLine);

      }
    });
  }

  addBpRow(): void {
    const myBpLineForm = this.bpComponentsService.createBpLine(this.form);
    const index = this.bpLineFormArray.length;
    const bpLineRef = this.bpComponentsService.getBpLineRef(index);
    const modalData = {
      referentiel: bpLineRef,
      bpLineForm: myBpLineForm,
      titre: 'Ajout d\'une ligne dans le BP'
    };
    const dialogRef = this.dialog.open(ModalCreateBpLineComponent, {
      autoFocus: false,
      disableClose: true,
      data: modalData
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.bpLineFormArray.push(res);
        this.reload();
      } else {
        this.bpComponentsService.cancelCreatedLine();
      }
    });
  }

  deleteRow(i: number, row: UntypedFormGroup): void {
    this.bpComponentsService.removeBpLine(this.form, i);
    this.reload();
  }

  changeAnnule(row): void {
    if (this.selection.isSelected(row)) {
      this.selection.deselect(row);
    } else {
      this.selection.select(row);
    }
    this.selected.emit(this.selection);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: BpLineModel): string {
    if (!row) {
      return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
    }
  }

  isAllSelected(): boolean {
    const numSelected = this.selection.selected.length;
    const numRows = this.matDataSourceBpLigne.data.length;
    return numSelected === numRows;
  }

  calculateHorsTaxe(object: any): void {
    this.amountHTs = this.amountService.getHt(object);
    this.amountHTsEmit.emit(this.amountHTs);
  }

  calculateTva(object: any): void {
    this.amountTVAs = this.amountService.getTva(object);
    this.amountTVAsEmit.emit(this.amountTVAs);
  }

  calculateTtc(object: any): void {
    this.amountTTCs = this.amountService.getTtc(object);
    this.amountTTCsEmit.emit(this.amountTTCs);
  }

  getCalculatedAMounts(): void {
    this.bpLineFormArray.valueChanges.subscribe(e => {
      this.calculateHorsTaxe(e);
      this.calculateTva(e);
      this.calculateTtc(e);
    });
  }
}

